import React from 'react';
import ButtonAction from '../ButtonAction';
import ElementCountListItem from './ElementCountListItem';
import { Container, Row, Col, Table, ButtonGroup, Button } from 'reactstrap';
import { fromJS } from 'immutable';

export default class ElementCountList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      itemCount: 1,
    };
  }

  render() {
    return (
      <div className='sample-count-panel'>
        <div className="sample-count-panel-head">
          <ButtonGroup>
            <Button
              onClick={() => {this.props.setAllElementCounts(0)}}
              title='set all element counts to zero'
            >
              Set All to 0
            </Button>
            <Button
              onClick={() => {this.props.setAllElementCounts(1)}}
              title='set all element counts to one'
            >
              Set All to 1
            </Button>
          </ButtonGroup>
        </div>
        <div className="sample-count-special-groups">
          <Button
            onClick={() => {this.props.selectAllByStyle("cn,ct,cs,ctbm,ctfm,pn,pt,ps,un,ut,us,au,au1,toc,toc1,toc2,toc3,toc4,toc5,tocbm,tocbmf,tocf,tocfm,tocfmf,tocpt,tocut,tocau".split(','))}}
            title='set major toc elements to max'
          >
            Select Common TOC/Title Styles
          </Button>
          <Button
            onClick={() => {this.props.selectAllByStyle("cn,ct,cs,ctbm,ctfm,pn,pt,ps,un,ut,us,au,au1,ah,ahaft,bh,bhaft,ch,chaft,dh,dhaft,eh,ehaft,hd,toc,toc1,toc2,toc3,toc4,toc5,tocbm,tocbmf,tocf,tocfm,tocfmf,tocpt,tocut,tocau,ctoch,ctoc,ctoc1".split(','))}}
            title='set all toc elements to max'
          >
            Select Common TOC/Title/Head Styles
          </Button>
          <Button
            onClick={() => {this.props.selectAllByStyle("tocill,figh".split(','))}}
            title='set all figure toc elements to max'
          >
            Select tocill/figh
          </Button>
          <Button
            onClick={() => {this.props.selectAllByStyle("toc,slh".split(','))}}
            title='set all poetry toc elements to max'
          >
            Select toc/slh
          </Button>
        </div>
        <div className="sample-element-scrollable">
          <Table hover responsive>
            <tbody>
              {this.props.elements.map((element, index) =>
                  (<tr key={`el${index}`}>
                    <td className="el-name">{element.name}</td>
                    <td className="el-count">
                      <ElementCountListItem
                        ref={element.name}
                        max={element.max}
                        count={element.count}
                        update={(c) => this.props.updateElementCount(element.name, c)}
                      />
                    </td>
                  </tr>),
              )}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
